{
  "nav": {
    "pricing": "Kainos",
    "contact": "Kontaktai",
    "menu": "Meniu",
    "login": "Prisijungti",
    "features": "Funkcijos",
    "brandHomeAria": "Done-it — pradžia",
    "market": {
      "belgium": "Belgija",
      "international": "Visame pasaulyje"
    }
  },
  "footer": {
    "tagline": "Done-it — Paprasta darbo laiko apskaita.",
    "terms": "Sąlygos",
    "privacy": "Privatumas",
    "contact": "Kontaktai"
  },
  "help": "Reikia pagalbos?",
  "continue": "Tęsti",
  "back": "Atgal",
  "change": "Keisti",
  "retry": "Bandyti dar kartą",
  "errors": {
    "unexpected": "Netikėta klaida"
  },
  "step": {
    "of": "Žingsnis {{n}} iš {{total}}"
  },
  "funnel": {
    "title": "Prenumerata · Done-it"
  }
}
